import Phaser from 'phaser';

import { AvailableFontSizes, TextService } from '../../services/text-service';
import { ResizeMetrics } from '../../model/resize-metrics';
import { Subscription } from 'rxjs';
import { RoundedLabelViewModel } from './rounded-label-view-model';
import { TwentyOneMainScene } from '../../scenes/twentyone-main-scene';
// import { DebugContainerVisual } from '../debug/debug-container-visual';

export class RoundedLabelView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: ResizeMetrics;
  private subscriptionGroup: Subscription;

  private graphics: Phaser.GameObjects.Graphics;
  private label: Phaser.GameObjects.Text;

  constructor(
    scene: TwentyOneMainScene,
    x: number,
    y: number,
    private viewModel: RoundedLabelViewModel,
  ) {
    super(scene, x, y);

    // new DebugContainerVisual(scene, this);

    this.subscriptionGroup = new Subscription();

    this.graphics = scene.add.graphics();
    this.add(this.graphics);

    const fontStyle = TextService.fontStyleBold(
      AvailableFontSizes.Medium,
      this.viewModel.labelColor,
      this.viewModel.defaultFontFamily,
    );

    this.label = this.scene.add.text(0, 0, '', fontStyle).setOrigin(0.5, 0.5);
    this.add(this.label);

    this.setName(RoundedLabelView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.currentText$.subscribe((text) => {
        this.label.text = text;
        this.refreshLayout();
      }),
    );
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.currentResizeMetrics = resizeMetrics;
    this.refreshLayout();
  }

  private refreshLayout(): void {
    if (!this.currentResizeMetrics) {
      return;
    }
    const layoutConfig = this.currentResizeMetrics.layoutConfig;
    const scalingMetrics = this.currentResizeMetrics.scalingMetrics;

    this.label.setFontSize(this.currentResizeMetrics.fontMetrics.Medium);

    const padding = layoutConfig.paddingSm * scalingMetrics.scaleFactor;
    this.setSize(this.label.width + padding * 2, this.label.height + padding);

    this.drawGraphics();
  }

  private drawGraphics(): void {
    this.graphics.clear(); // Clear previous drawings

    this.graphics.fillStyle(this.viewModel.backgroundColor, this.viewModel.backgroundAlpha);
    this.graphics.fillRoundedRect(
      this.width * -0.5,
      this.height * -0.5,
      this.width,
      this.height,
      this.height * 0.1,
    );
    this.graphics.setDepth(1);
  }
}
